import Banner2 from './Banner2'
export default Banner2;

